export const eachSlice = <T>(arr: T[], n: number = 2) => {
  const dup = [...arr]
  const result = [];
  let length = dup.length;

  while (0 < length) {
    result.push(dup.splice(0, n));
    length = dup.length
  }

  return result;
};

export const intersect = <T>(arr1: T[], arr2: T[]) => {
  if(!arr1) throw new Error()
  if(!arr2) throw new Error()
  const arr2Set: Set<any> = new Set(arr2)
  return [...new Set(arr1)].filter(x => arr2Set.has(x))
}

/**
 * 検査対象が、検査条件の前方一致になっているかどうかを返す.
 * @param conditionWords 検査条件の文字列配列
 * @param checkTargetWords 検査対象の文字列配列
 * @returns 検査対象が、検査条件の前方一致になっている場合にtrue. それ以外はfalse.
 */
export const isForwardMatch = (conditionWords: string[], checkTargetWords: string[]) => {
  // 検査対象が空の場合は、対象外
  if (checkTargetWords.length < 1) return false

  for (let i = 0; i < conditionWords.length; ++i) {
    if(conditionWords[i] !== checkTargetWords[i]) return false
  }
  return true
};

export type SortedFilterItem = { level: number, filterItem: string };
export type FilterItem = SortedFilterItem & { count: number };

/**
 * フィルター項目リストのソート処理（枚数が多い順 同じ場合は、文字列のソート順（A→Z）になる）.
 * @param filterItemList フィルター項目
 * @returns ソート後のフィルター項目
 */
 export const sortFilterItemList: (filterItemList: FilterItem[]) => SortedFilterItem[] = 
 (filterItemList: FilterItem[]) => {
  return [...filterItemList].sort((a, b) => {
    // 枚数が同じ場合
    if(a.count === b.count){
        // 文字列ソート
      if(a.filterItem < b.filterItem) return -1
      else return 1
    }
    // 枚数が多い順
    else return (b.count - a.count)
  })
  // 件数情報は画面では使用しないので、削除する
  .map( item => { return { level: item.level, filterItem: item.filterItem }})
};
